import React from "react";

export function DtiRefreshLabel() {
  return <strong className="dti-text-primary">Cập nhật dữ liệu</strong>;
}

export const DTI_REFRESH_HINT = (
  <>
    Dữ liệu lấy từ hệ thống LMS của trường. Nhấn <DtiRefreshLabel /> để đồng bộ mới nhất
  </>
);

export const DTI_REFRESH_EMPTY_MESSAGE = (
  <>
    Nhấn <DtiRefreshLabel /> để đồng bộ từ hệ thống LMS
  </>
);
